import { FontsService } from './';

export default function isCustomFont({ service }) {
  return service === FontsService.custom;
}